import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tabbed-slide" }
const _hoisted_2 = { class: "tabbed-slide__image-container" }
const _hoisted_3 = {
  class: "tabbed-slide__image",
  ref: "imageContainer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "tabbed-slide__overlay-filler" }, null, -1)
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "tabbed-slide__overlay-filler" }, null, -1)
const _hoisted_7 = { class: "tabbed-slide__title-container" }
const _hoisted_8 = {
  key: 0,
  class: "w-100",
  "cms:edit": "bar"
}
const _hoisted_9 = { class: "tabbed-slide__title" }
const _hoisted_10 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ], 512),
      _hoisted_4,
      _createElementVNode("img", {
        class: "tabbed-slide__img",
        src: _ctx.determineOverlayImagePath(),
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.svgLoaded && _ctx.svgLoaded(...args))),
        alt: _ctx.title
      }, null, 40, _hoisted_5),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.title), 1),
      _createElementVNode("a", {
        href: _ctx.link,
        class: "button tabbed-slide__button",
        target: _ctx.linkTarget
      }, _toDisplayString(_ctx.linkLabel), 9, _hoisted_10)
    ])
  ], 512)), [
    [_vShow, _ctx.active]
  ])
}